import { Card, DatePicker, Typography } from 'antd';
import { Dayjs } from 'dayjs';
import React from 'react';

const { Text } = Typography;
const { RangePicker } = DatePicker;

interface DateDisplayProps {
  range: [Dayjs, Dayjs] | null;
  type?: 'primary' | 'compare';
  label: string;
  onChange?: (dates: [Dayjs, Dayjs] | null) => void;
  disabled?: boolean;
}

const DateDisplay: React.FC<DateDisplayProps> = ({
  range, 
  label,
  onChange,
  disabled = true
}) => {
  return (
    <div style={{ width: 230 }}>
      <Text type='secondary'  style={{ display: 'block', marginBottom: 8 }}>
        {label}
      </Text>
      <Card 
        size="small"
      >
        <RangePicker
          value={range}
          onChange={(dates) => onChange?.(dates as [Dayjs, Dayjs] | null)}
          format="DD-MM-YYYY"
          disabled={disabled}
        />
      </Card>
    </div>
  );
};

export default DateDisplay;